import { useMutation } from "@tanstack/react-query";
import { config } from "@/lib/config";
import type { components } from "@shared/types/api";

type VerifyMagicLinkRequest = components["schemas"]["VerifyMagicLinkRequest"];
type VerifyMagicLinkResponse = components["schemas"]["VerifyMagicLinkResponse"];

// Request type with required password for verification flow
interface VerifyMagicLinkParams {
    token: string;
    password: string;
}

export function useVerifyMagicLinkMutation() {
    return useMutation({
        mutationFn: async ({ token, password }: VerifyMagicLinkParams): Promise<VerifyMagicLinkResponse> => {
            const baseUrl = config.apiUrl;
            const response = await fetch(`${baseUrl}/api/v1/auth/verify-magic-link`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ token, password }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(
                    errorData.error || `HTTP error! status: ${response.status}`,
                );
            }

            return response.json() as Promise<VerifyMagicLinkResponse>;
        },
    });
}
